import React,{FC,useState,useEffect} from 'react'
import {Grid,Divider,Theme, Typography,useMediaQuery,useTheme, Button } from '@mui/material'
import { createStyles, makeStyles } from "@mui/styles";
import ScheduleTimes from './components/scheduleTimes';
import useUniqueSchedules from 'hooks/useUniqueSchedules';
import DRProfile from './components/doctorProfile';
import { useStore } from 'store/StoreProvider';
import { useSession } from 'hooks/SessionProvider';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useRoute } from 'hooks/RouteProvider';
import { customRoutes } from 'utils/constants';
interface Props {
  schedules?: any;
  inView?:any;
  setInView?:any;
  setSchFullLength?:any;
}

const useStyles = makeStyles((theme:Theme) =>
    createStyles({
        DRScheduelsMain:{
            [theme.breakpoints.up('md')]:{
                display:"flex",
                justifyContent:"space-between !important",
          
            },
            minHeight:"190px",
        },
        scheduleTimesMain:{
            [theme.breakpoints.up('md')]:{
                width:"100%",
                paddingLeft:"50px",
                paddingRight:"55px",
            },
              [theme.breakpoints.up('xl')]:{
                width:"80% !important",
                paddingLeft:"47px !important",
                paddingRight:"55px !important",
            },
        },
        DRProfileMain:{
            [theme.breakpoints.up('md')]:{
                width:"47%",
            },
            [theme.breakpoints.up('xl')]:{
                width:"35%",
            }
        },
        backButton:{
          borderRadius:"10px !important",
          borderColor:"#d6d6d6 !important",
          color:"#004852 !important",
          width:"100%",
          backgroundColor: 'white !important',
          '&:hover': {
          backgroundColor: '#f6f6f6 !important',
        },
          [theme.breakpoints.up('md')]:{
              paddingLeft:"40px !important",
              paddingRight:"40px !important",
          }
      }, 
      text: {
        flexGrow: 1,
        textAlign: 'center',
      },
    })
  );
const DRSchedules: FC<Props>=({schedules,inView,setInView,setSchFullLength}) => {
    const classes = useStyles();
    const uniqueSchedules=useUniqueSchedules(schedules)
    const [visibleCount, setVisibleCount] = useState(5); // Initial number of schedules to display
    const store=useStore();
    const data=store.getData();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const slicedSchedules = !isSmallScreen ? uniqueSchedules.slice(0, visibleCount) : uniqueSchedules;
    const { navigate } = useRoute();
    

    useEffect(() => {
        if (inView && uniqueSchedules.length>visibleCount) {
        setVisibleCount((prevCount) => prevCount + 5); // Load 5 more schedules
        }
        
        if(inView && uniqueSchedules.length<=visibleCount) setSchFullLength(true)
        setInView(false)
    }, [inView]);

    const onBackPressed=()=>{
      navigate(customRoutes.APTDetails)
    }

  return (
    <Grid >
       <Grid>
        {slicedSchedules.map((item: any, index: number) => (
          <Grid key={index} sx={{ marginBottom: '30px' }}>
            <Grid className={classes.DRScheduelsMain}>
              <Grid className={classes.DRProfileMain}>
                <DRProfile doctorId={item?.sch_doctor_ids} addressID={item?.address_id} isUseAvtar={false} />
              </Grid>
              <Grid className={classes.scheduleTimesMain}>
                <ScheduleTimes doctorId={item?.sch_doctor_ids} addressID={item?.address_id} />
              </Grid>
            </Grid>
            <Divider />
          </Grid>
        ))}

          {isSmallScreen && <
            Grid sx={{marginBottom:"20px"}}>
              <Button variant='outlined'  
                className={classes.backButton} 
                sx={{textTransform: "none",}} 
                onClick={onBackPressed}>
              <ArrowBackIcon/>
                {<span className={classes.text}>Go Back</span>}
              </Button> 
            </Grid>
            }
      </Grid>
    </Grid>
  )
}

export default DRSchedules